module.exports = __webpack_public_path__ + "files/8c3e37bec0f4443590ccb69da57c1a04.png";